import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import boxesImg from './images/img-boxes@2x.jpg';
import bestValuePng from './images/badge-best-value@2x.png';
import shapeSvg from './images/shape.svg';
import { Plans } from '../constants';
import { planDisclaimer } from './constants';

const DesktopLayout = ({ handleChangeActive, active, onClickUpgrade }) => (
  <>
    <section className="trial-upgrade__container" style={{ backgroundImage: `url(${boxesImg})` }}>
      <section className="trial-upgrade">
        <div className="trial-upgrade__right">
          <div className="trial-upgrade__title">
            Ready to Start Your Membership?
          </div>
          <div className="trial-upgrade__subtitle">
            Starting your membership early ensures you start with the box you want.
          </div>
          <div className="trial-upgrade__buttons">
            <div
              className={cx('trial-upgrade__buttons__box', { active: active === Plans.SEASONAL })}
              role="button"
              tabIndex="0"
              onClick={() => handleChangeActive(Plans.SEASONAL)}
              onKeyDown={() => handleChangeActive(Plans.SEASONAL)}
            >
              {active === Plans.SEASONAL && <div className="active-check"><img src={shapeSvg} alt="active" /></div>}
              <div className="trial-upgrade__buttons__title">
                SEASONAL
              </div>
              <div className="trial-upgrade__buttons__price">
                $49.99 USD
              </div>
              <div className="trial-upgrade__buttons__type">
                Standard
              </div>
            </div>
            <div
              className={cx('trial-upgrade__buttons__box', { active: active === Plans.ANNUAL })}
              role="button"
              tabIndex="0"
              onClick={() => handleChangeActive(Plans.ANNUAL)}
              onKeyDown={() => handleChangeActive(Plans.ANNUAL)}
            >
              {active === Plans.ANNUAL && <div className="active-check"><img src={shapeSvg} alt="active" /></div>}
              <div className="trial-upgrade__buttons__title">
                ANNUAL
              </div>
              <div className="trial-upgrade__buttons__price through">
                $199.99 USD
              </div>
              <div className="trial-upgrade__buttons__price spaced">
                $179.99 USD!
              </div>
            </div>
          </div>
          <div className="trial-upgrade__next">
            <div className="trial-upgrade__next__title">
              Next Box: Summer 2021 Box
            </div>
            <div className="trial-upgrade__next__description">
              {active === Plans.ANNUAL ? planDisclaimer.ANNUAL : planDisclaimer.SEASONAL}
            </div>
            <div className="trial-upgrade__next__button">
              <button type="button" className="fff-btn-primary" onClick={() => onClickUpgrade(active)}>
                CONFIRM PURCHASE
              </button>
            </div>
            <div className="trial-upgrade__next__additional">
              *Additional $8/box shipping for Canada, Hawaii, Alaska, and
              Puerto Rico. Sales tax may apply (learn more).
            </div>
          </div>
        </div>
      </section>
    </section>
    <section className="trial-upgrade-detail">
      <p className="trial-upgrade-detail__title">Let’s Get Started</p>
      <div className="trial-upgrade-detail__cards">
        <div className="trial-upgrade-detail__card">
          <div className="trial-upgrade-detail__card__title">Seasonal</div>
          <div className="trial-upgrade-detail__card__price">
            <span className="sign">$</span>
            49.99
            <span className="unit">/ box</span>
          </div>
          <div className="trial-upgrade-detail__card__detail">
            Pay Per Seasonal Box
            <br />
            + Free Shipping!
          </div>
          <div className="trial-upgrade-detail__card__checklist">
            <ul className="plan-options">
              <li>
                <span>The Seasonal Box</span>
              </li>
              <li>
                <span>Customize your box</span>
              </li>
              <li>
                <span>Members Only Sales</span>
              </li>
              <li>
                <span>FabFitFun TV</span>
              </li>
              <li>
                <span>The Community Forum</span>
              </li>
              <li className="strike-through">
                <span>More box customization options each season</span>
              </li>
              <li className="strike-through">
                <span>Early access to member’s only sales</span>
              </li>
              <li className="strike-through">
                <span>Earlier shipping with our first billing/shipping date</span>
              </li>
            </ul>
          </div>
          <button className="fff-btn-primary" type="button" onClick={() => onClickUpgrade(Plans.SEASONAL)}>
            SELECT SEASONAL
          </button>
        </div>
        <div className="trial-upgrade-detail__card">
          <img className="trial-upgrade-detail__best-value" src={bestValuePng} alt="best value" />
          <div className="trial-upgrade-detail__card__title">Annual</div>
          <div className="trial-upgrade-detail__card__price">
            <span className="sign">$</span>
            179.99
            <span className="unit">/ year</span>
          </div>
          <div className="trial-upgrade-detail__card__detail">
            $20 Instant Savings
            <br />
            When you Prepay for 4 Boxes
            <br />
            + Free Shipping!
          </div>
          <div className="trial-upgrade-detail__card__checklist">
            <ul className="plan-options">
              <li>
                The Seasonal Box
              </li>
              <li>
                Customize your box
              </li>
              <li>
                Members Only Sales
              </li>
              <li>
                FabFitFun TV
              </li>
              <li>
                The Community Forum
              </li>
              <li>
                More box customization options each season
              </li>
              <li>
                Early access to member’s only sales
              </li>
              <li>
                Earlier shipping with our first billing/
                <br />
                shipping date
              </li>
            </ul>
          </div>
          <button className="fff-btn-primary" type="button" onClick={() => onClickUpgrade(Plans.ANNUAL)}>
            SELECT ANNUAL
          </button>
        </div>
      </div>
    </section>
  </>
);

DesktopLayout.defaultProps = {
  handleChangeActive: () => null,
  active: Plans.SEASONAL,
};

DesktopLayout.propTypes = {
  handleChangeActive: PropTypes.func,
  active: PropTypes.string,
};

export default DesktopLayout;
